export default function redirectTo(string) {
  window.open(string, "_blank").focus();
}
